import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatObservation as createObservationApi,
    updateObservation as updateObservationApi,
    getAllObservation as getAllObservationApi,
    getObservation as getObservationApi,
    getObservationReport as getObservationReportApi,
    deleteObservation as deleteObservationApi,
    getObservations as getObservationsApi,
    getObservationStatus as getObservationStatusApi,
    sendEmailObservation as sendEmailObservationApi,
} from './api';

// actions
import { observationApiResponseSuccess, observationApiResponseError } from './actions';

// constants
import { ObservationActionTypes } from './constants';

type ObservationData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Observation
 * @param {*} payload
 */
function* AddObservation({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(createObservationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.ADD_OBSERVATION,
                    data,
                    'Observation has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Observation!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(ObservationActionTypes.ADD_OBSERVATION, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(observationApiResponseError(ObservationActionTypes.ADD_OBSERVATION, [], error, 404, true, false));
    }
}

/**
 * Send Email Observation
 * @param {*} payload
 */
function* SendEmailObservation({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(sendEmailObservationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.SEND_EMAIL_OBSERVATION,
                    data,
                    'Email Send successfully.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while send email!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.SEND_EMAIL_OBSERVATION,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            observationApiResponseError(ObservationActionTypes.SEND_EMAIL_OBSERVATION, [], error, 404, true, false)
        );
    }
}

/**
 * Edit Observation
 * @param {*} payload
 */
function* EditObservation({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(updateObservationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.EDIT_OBSERVATION,
                    data,
                    'Observation Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Observation!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(ObservationActionTypes.EDIT_OBSERVATION, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(observationApiResponseError(ObservationActionTypes.EDIT_OBSERVATION, [], error, 404, true, false));
    }
}

/**
 * Fetch Observation
 * @param {*} payload
 */
function* GetObservation({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(getObservationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(ObservationActionTypes.GET_OBSERVATION, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Observation!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(ObservationActionTypes.GET_OBSERVATION, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(observationApiResponseError(ObservationActionTypes.GET_OBSERVATION, [], error, 404, true, false));
    }
}

/**
 * Fetch Observations
 * @param {*} payload
 */
function* GetObservations({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(getAllObservationApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATIONS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Observation Listing!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATIONS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(observationApiResponseError(ObservationActionTypes.GET_OBSERVATIONS, [], error, 404, true, false));
    }
}

/**
 * Fetch Observations Status
 * @param {*} payload
 */
function* GetObservationStatus({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(getObservationStatusApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATIONS_STATUS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Observation Listing!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATIONS_STATUS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            observationApiResponseError(ObservationActionTypes.GET_OBSERVATIONS_STATUS, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Observations
 * @param {*} payload
 */
function* GetObservationList({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(getObservationsApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATION_LIST,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Observation Listing!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATION_LIST,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            observationApiResponseError(ObservationActionTypes.GET_OBSERVATION_LIST, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Observations
 * @param {*} payload
 */
function* GetObservationReport({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(getObservationReportApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATION_REPORT,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Observation Report Listing!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.GET_OBSERVATION_REPORT,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            observationApiResponseError(ObservationActionTypes.GET_OBSERVATION_REPORT, [], error, 404, true, false)
        );
    }
}

/**
 * Delete Observation
 * @param {*} payload
 */
function* DeleteObservation({ payload, type }: ObservationData): SagaIterator {
    try {
        const response = yield call(deleteObservationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                observationApiResponseSuccess(
                    ObservationActionTypes.DELETE_OBSERVATION,
                    data,
                    'Observation Deleted Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while delete Observation!`;
            if (message) msg = message;
            yield put(
                observationApiResponseSuccess(ObservationActionTypes.DELETE_OBSERVATION, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(observationApiResponseError(ObservationActionTypes.DELETE_OBSERVATION, [], error, 404, true, false));
    }
}

export function* watchGetObservation() {
    yield takeEvery(ObservationActionTypes.GET_OBSERVATION, GetObservation);
}

export function* watchGetObservationStatus() {
    yield takeEvery(ObservationActionTypes.GET_OBSERVATIONS_STATUS, GetObservationStatus);
}

export function* watchGetObservations() {
    yield takeEvery(ObservationActionTypes.GET_OBSERVATIONS, GetObservations);
}

export function* watchGetObservationList() {
    yield takeEvery(ObservationActionTypes.GET_OBSERVATION_LIST, GetObservationList);
}

export function* watchGetObservationReport() {
    yield takeEvery(ObservationActionTypes.GET_OBSERVATION_REPORT, GetObservationReport);
}

export function* watchAddObservation() {
    yield takeEvery(ObservationActionTypes.ADD_OBSERVATION, AddObservation);
}

export function* watchSendEmailObservation() {
    yield takeEvery(ObservationActionTypes.SEND_EMAIL_OBSERVATION, SendEmailObservation);
}

export function* watchEditObservation(): any {
    yield takeEvery(ObservationActionTypes.EDIT_OBSERVATION, EditObservation);
}

export function* watchDeleteObservation(): any {
    yield takeEvery(ObservationActionTypes.DELETE_OBSERVATION, DeleteObservation);
}

function* observationSaga() {
    yield all([
        fork(watchGetObservation),
        fork(watchAddObservation),
        fork(watchEditObservation),
        fork(watchGetObservations),
        fork(watchGetObservationReport),
        fork(watchDeleteObservation),
        fork(watchGetObservationList),
        fork(watchSendEmailObservation),
        fork(watchGetObservationStatus),
    ]);
}

export default observationSaga;
